<template>
  <!-- 我的定制方案 -->
  <div class="record">
    <van-tabs v-model="active" @click="listSelect">
      <van-tab v-for="tag in tagList" :title="tag" :key="tag.id"></van-tab>
    </van-tabs>
    <div class="h12"></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  v-show="list.length > 0">
      <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
      <div class="record-item-list" v-for="item in list">
        <div class="record-top" @click="enter(item)">
          <div class="record-item">
            <p class="title-1">{{item.projectName}}</p>
            <a class="pan dbj dbj-back"  :class="`dbj-back`+item.newStatus">{{item.newStatus | newStatus}}</a>
          </div>
          <div class="record-item">
            <p class="title-2">
              <span>业态：</span>
              <span v-for="cell in item.buildingType" :key="item.id">{{ cell.name }}</span>
              <span v-for="cell in item.secondBuildingTypeList" :key="item.id"> {{ cell.name }}</span>
            </p>
            <!-- <p>预算<span>￥0.01</span></p> -->
          </div>
        </div>
        <div class="record-item-bottom">
          <p>{{item.createdTime}}</p>
          <a class="enter-price" v-if="item.newStatus==20" @click="enter(item)">立即支付</a>
          <a class="enter-price" v-if="item.newStatus==4" @click="enter(item)">验收</a>
        </div>
        <div class="h08"></div>
      </div>

    </van-list>
    <noPaymentList v-show="list.length == 0" :noResultData="noResultData"  @toListSelf="toListSelf"></noPaymentList>
    <!-- <div class="no-data">
      <img src="https://project-homedo.oss-cn-shanghai.aliyuncs.com/bd9f18a8-2069-4276-b6f2-9fe35dfba78e_nn-d.png" alt="">
      <div>暂无内容</div>
    </div> -->
  </div>
</template>

<script>
  import noPaymentList from '@/components/noPaymentList'

  import { myCaseList } from '@/api/userPerson/userPerson'
  import { getCookie } from '@/utils/cookies'
  import { newStatus } from '@/filters/status'
  export default {
    data() {
      return {
        active: 0,
        loading: false,
        finished: false,
        tagList: ['全部', '待支付', '待派单', '设计中', '待验收','已完成','已取消'],
        list: [],
        hraderP: {
          title: '我的定制方案',
          lefticon: true
        },
        noResultData: {
          typeName: '方案',
          callback: 'callback'
        },
        listQuery:{
          current: 1,
          size: 10,
          newStatus:'',//订单状态 20：待支付 30：待派单 50：已取消 1-待接单；2-设计中；3-待审核；4-待验收；5-已完成;6-已拒绝
          userId:''
        },
      }
    },
    filters: {
      newStatus
    },
    components: { noPaymentList },
    created() {
       this.listQuery.userId = getCookie('accountId')
       this.getData()
    },
    methods: {
      listSelect (index, title) {
        this.active = index
        this.list = []
       switch (title) {
        case '待支付':
           this.listQuery.newStatus = 20
           break
        case '待派单':
            this.listQuery.newStatus = 30
           break
        case '设计中':
            this.listQuery.newStatus = 2
           break
        case '待验收':
            this.listQuery.newStatus = 4
           break
        case '已完成':
            this.listQuery.newStatus = 5
           break
        case '已取消':
            this.listQuery.newStatus = 50
           break
        case '全部':
           this.listQuery.newStatus = ''
           break
       }
       this.getData()
      },
      toListSelf () {
        this.getData()
      },
      getData(){
        this.listQuery.current = 0
        this.listQuery.size = 10
        this.finished = false
        this.onLoad()
      },
      enter(item){
        this.$router.push(`/userPerson/mycaseDetail.html?orderNo=${item.orderNo}&reqId=${item.reqId}`)
      },
      onLoad () {
         // 调用查询接口
         let self = this
         this.listQuery.current++
         myCaseList(this.listQuery).then(result => {
            if (result && result.status === 200 && result.data  && result.data.data.records && result.data.data.records.length > 0) {
             self.list = self.list.concat(result.data.data.records)
             self.listQuery.current = result.data.data.current
             window.setTimeout(() => {
               self.loading = false
               console.log(self.list,'self.list');
               console.log(result.data.data.total,'result.data.data.total');
               if (self.list.length === result.data.data.total) {
                 self.finished = true
               }
             }, 1000)
           } else {
             self.loading = false
             self.finished = true
           }
         }).catch(() => {
           self.loading = false
           self.listQuery.total = 0
         })
      },
    }
  }
</script>

<style lang="scss">
  .record {
    .van-tab {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
    }

    .van-tab--active {
      color: #2F7BFF;
      font-weight: bold;
    }

    .van-tabs__line {
      height: 2px;
      background-color: #2F7BFF !important;
    }
  }
</style>
<style lang="scss" scoped>
  .record {
    .record-item-list {
      margin-bottom: 8px;
      background: #fff;

      .record-top {
        padding: 16px 13px 0 20px;

        .record-item {
          display: flex;
          justify-content: space-between;
          padding-bottom: 12px;

          .title-1 {
            font-size: 15px;
            color: rgba(0, 0, 0, 0.65);
            font-weight: 600;
          }

          .title-2 {
            font-size: 12px;
            color: #787878;
          }
          .pan{
            display: inline-block;
            width: 74px;
            height: 18px;
            line-height: 19px;
            font-size: 12px;
            background-size: 100% 100%;
            text-align: center;
          }
          .dbj{
            color: #FF6900;
          }
          .dbj-back{
             background-image:url(../../assets/images/orange.png);
          }
          .ybj{
            color: #14AE14;
          }
          .dbj-back20,.dbj-back20,.dbj-back4{
            color: #FF6900;
            background-image:url(../../assets/images/orange.png);
          }
          .dbj-back2{
            color: #2F7BFF;
            background-image:url(../../assets/images/blue.png);
          }
          .dbj-back5{
            color: #14AE14;
            background-image:url(../../assets/images/green.png);
          }
          .dbj-back50{
            color: #B5B5B5;
            background-image:url(../../assets/images/gray.png);
          }
          .ybj-back{
             background-image:url(../../assets/images/green.png);
          }
          .ygq{
            color: #B5B5B5
          }
          .ygq-back{
             background-image:url(../../assets/images/gray.png);
          }
          span {
            color: #FF0000;
          }
        }
      }

      .record-item-bottom {
        background: #F9FBFF;
        padding: 11px 13px 11px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 12px;
          font-weight: 600;
          color: #2F7BFF;
          height: 27px;
          line-height: 27px;
        }

        .enter-price {
          width: 79px;
          display: inline-block;
          height: 27px;
          line-height: 27px;
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          color: #FFFFFF;
          background: linear-gradient(90deg, #FFA200 0%, #FF6900 100%, #FF6900 100%);
          border-radius: 13px;
        }
      }
    }
  }

  .h12 {
    height: 12px;
  }
  .h08 {
    height: 8px;
    background: #EFEFF4;
  }
</style>



// WEBPACK FOOTER //
// src/view/userPerson/mycase.vue